/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdvancedSearchAddress } from './';
import {
    AdvancedSearchAddressFromJSON,
    AdvancedSearchAddressFromJSONTyped,
    AdvancedSearchAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearch
 */
export interface AdvancedSearch {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdvancedSearch
     */
    skills: Array<string>;
    /**
     * 
     * @type {AdvancedSearchAddress}
     * @memberof AdvancedSearch
     */
    address?: AdvancedSearchAddress;
}

/**
 * Check if a given object implements the AdvancedSearch interface.
 */
export function instanceOfAdvancedSearch(value: object): value is AdvancedSearch {
    if (!('skills' in value) || value['skills'] === undefined) return false;
    return true;
}

export function AdvancedSearchFromJSON(json: any): AdvancedSearch {
    return AdvancedSearchFromJSONTyped(json, false);
}

export function AdvancedSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearch {
    if (json == null) {
        return json;
    }
    return {
        
        'skills': json['skills'],
        'address': json['address'] == null ? undefined : AdvancedSearchAddressFromJSON(json['address']),
    };
}

export function AdvancedSearchToJSON(value?: AdvancedSearch | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'skills': value['skills'],
        'address': AdvancedSearchAddressToJSON(value['address']),
    };
}

